export default [
  {
    id: '1',
    title: 'PPE Production',
    finsought: '$5 - $20 million',
    country: 'South Africa',
    sector: 'Healthcare',
    isEquityInvestment: true,
    isDebtInvestment: true,
    brief: 'Local producer of melt blown fabric, the primary input in medical grade personal protection equipment (PPE). Currently focused on regional African markets, but looking to expand to cover all of Africa and external markets. First of its kind producer of intermediate PPE materials in Africa.'
  },
  {
    id: '2',
    title: 'Maternity Products Provider',
    finsought: '$1 - $5 million',
    country: 'Kenya',
    sector: 'Healthcare',
    isEquityInvestment: true,
    isDebtInvestment: false,
    brief: 'Seed stage, tech-enabled marketplace and community platform for African mothers and families.'
  }
]
